import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './NavigationStyles';

export default class AssistedLivingNavigation extends Component {
  render() {
    const { pathname } = this.props

    return (
      <div className={css(styles.navigation)}>
        <nav className={css(styles.innerContent)}>
          <ul className={css(styles.list)}>
            <li className={css(styles.listItem)}>
              <a href="/parents-home" className={css(styles.link, styles.iconAlerts, pathname === "/parents-home" && styles.assistedActive)}>
                <span className={css(styles.text)}>Alerts</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/parents-home/activities" className={css(styles.link, styles.iconActivities, pathname.includes("/parents-home/activities") && styles.assistedActive)}>
                <span className={css(styles.text)}>Activities</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/parents-home/appliances" className={css(styles.link, styles.iconAppliances, (pathname === "/parents-home/appliances" || pathname.indexOf("/parents-home/appliance/") === 0) && styles.assistedActive)}>
                <span className={css(styles.text)}>Appliances</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/parents-home/feedback" className={css(styles.link, styles.iconFeedback, pathname === "/parents-home/feedback" && styles.assistedActive)}>
                <span className={css(styles.text)}>Feedback</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}
